export default [
    {
        path: "/",
        name: "index",
        component: () => import("@/views/Landing"),
        meta: {
            layout: "base"
        }
    },
    {
        path: "/support",
        name: "support",
        component: () => import("@/views/Support"),
        meta: {
            layout: "base"
        }
    },
    {
        path: "/pricing",
        name: "pricing",
        component: () => import("@/views/Pricing"),
        meta: {
            layout: "base"
        }
    },
    {
        path: "/update",
        name: "update",
        component: () => import("@/views/Update"),
        meta: {
            layout: "base"
        }
    },

    {
        path: "/terms-and-conditions",
        name: "terms",
        component: () => import("@/views/Terms"),
        meta: {
            layout: "base"
        }
    },

    {
        path: "/privacy-policy",
        name: "privacy",
        component: () => import("@/views/Privacy"),
        meta: {
            layout: "base"
        }
    },

    {
        path: "/disclaimer",
        name: "disclaimer",
        component: () => import("@/views/Disclaimer"),
        meta: {
            layout: "base"
        }
    },

    {
        path: "/register",
        name: "register",
        component: () => import("@/views/Register"),
        meta: {
            layout: "base"
        }
    },

    {
        path: "*",
        name: "404",
        component: () => import("@/views/Error"),
        meta: {
            layout: "base"
        }
    }
];
